import { render } from "./Organisatie.vue?vue&type=template&id=33d78290&scoped=true"
import script from "./Organisatie.vue?vue&type=script&lang=js"
export * from "./Organisatie.vue?vue&type=script&lang=js"

import "./Organisatie.vue?vue&type=style&index=0&id=33d78290&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d78290"]])

export default __exports__